import { tApi, User } from 'tplus-api';
import { history, localStore } from 'mutants-microfx';
import { voucherColumns, planInfo } from '../fixedViewInfo';
import modules from '../modules';
import setData from '../config/setData'

export const appMenuKey = { sysid: 'RE', mid: 'RE01' };
const reloginErrorCodes = ['EXSM0003', 'EXSM0004', 'EXSM0005']

export const dataProvider = {
  async getModule({ sysid, mid }) {
    const data = modules[`${sysid}_${mid}`]
    return data;
  },

  async getDataInfo({ sysid, mid }) {
    const param = {
      "vouchername": "NewRetail"
    };
    try {
      const data = await tApi(param, 'chanjet.RE.INewRetailVoucherService.GetVoucherDataInfo', false, false);
      return data;
    } catch (err) {
      if (reloginErrorCodes.some(reloginErrorCode => { return reloginErrorCode === err.Code })) {
        //需要重新登录时  因为dom没有加载  所以监听失效  需要控制路由跳转
        //history.replace(`/login?redirect=${history.location.pathname}`);
        history.replace(`/login`);
      }
    }

  },

  async getData({ sysid, mid, id }) {
    // if(tools.isNull)return null;
    // let key=sysid+'_'+mid;
    // return dataLocalStore.get(key);
    return null;
  },

  async getViewInfo({ sysid, mid }) {
    let params = {
      "vouchername": "NewRetail"
    }
    let returnValue = this.getVoucherMode();
    params = (returnValue == "voucher") ? { "vouchername": "RetailOrder" } : params;
    let voucherViewInfo;
    voucherViewInfo = await tApi(params, 'chanjet.RE.INewRetailVoucherService.GetVoucherViewInfo', false, false);
    console.log('voucherViewInfo======', JSON.stringify(voucherViewInfo));
    voucherViewInfo = {
      VoucherColumns: voucherColumns,
      VoucherDetail: voucherViewInfo.Headers
    }
    const operations = await tApi(params, 'chanjet.RE.INewPos.GetOperations', false, false);
    let viewInfoHandle = {
      Voucher: voucherViewInfo,
      Operations: operations,
      TextBoxModal: '',
      FreeItemsModal: '',
      BatchModal: '',
      planInfo,
      MemberStore: ''
    }
    return viewInfoHandle;
  },

  getVoucherMode() {
    /* 获取开单模式:touch、voucher */
    const data = localStore.get("setting_setData") || [];
    let configure = {}
    if (Array.isArray(data)) {//接口数据为数组
      configure = setData.getVoucherDefaultPosMode(data)
    }
    let returnValue = null;
    if (configure && configure.default) {
      returnValue = configure.default
    }
    if (returnValue) localStore && localStore.set('voucherDefaultPosMode', returnValue);
    return returnValue;
  }
}